module.exports = __webpack_public_path__ + "img/MPV.1ae4e03f.svg";